import { Info } from "lucide-react";
import React from "react";
import { cn } from "@/lib/utils";

const InfoBulle: React.FC<{
  message: string;
  /** classes du conteneur (largeur, marges…) */
  className?: string;
  /** classes du texte (ex. `font-semibold` pour un disclaimer accentué) */
  textClassName?: string;
}> = ({ message, className, textClassName }) => {
  return (
    <div className={cn("flex border-[1px] rounded-xl p-2", className)}>
      <div className="flex items-center">
        <Info
          className="flex shrink-0 items-center"
          color="grey"
          size="20"
        />
      </div>
      <span className={cn("text-[14px] font-['Raleway'] ml-2", textClassName)}>
        {message}
      </span>
    </div>
  );
};

export default InfoBulle;
